export default "__VITE_ASSET__DUMds9iU__"